export const medicalCardApi = {
  createMedicalCard: (): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-forms`,
  updateMedicalCard: (medicalCardId: string): string =>
    `/api/portal/staff/medical/doctor/patient-qualification-forms/${medicalCardId}`,
  fetchPatientMedicalCardList: (userId: string): string =>
    `/api/portal/staff/patients/${userId}/patient-qualification-forms`,
  fetchPatientMedicalCard: (medicalCardId: string): string =>
    `/api/portal/staff/patients/patient-qualification-forms/${medicalCardId}`,
  downloadMedicalCard: (medicalCardId: string): string =>
    `/api/portal/staff/patients/patient-qualification-forms/${medicalCardId}/download`,
};
